import {ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';
import {NgSelectModule} from '@ng-select/ng-select';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {IonicStorageModule} from '@ionic/storage-angular';
import {Drivers} from '@ionic/storage';
import {TokenInterceptor} from './interceptors/token.interceptor';
import {ImageModalPageModule} from 'src/app/pages/image-modal/image-modal.module';
import {LoggerService} from './services/logger.service';
import {FullCalendarModule} from '@fullcalendar/angular';
import {DatePipe} from '@angular/common';
import {GlobalErrorHandler} from './services/global-error-handler';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      swipeBackEnabled: false,
      mode: 'ios',
    }),
    AppRoutingModule,
    IonicStorageModule.forRoot({
      name: '__myCrewMobile',
      driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
    }),
    ImageModalPageModule,
    FullCalendarModule,
    NgSelectModule,
  ],
  providers: [
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
    // OneSignal,
    LoggerService,
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
